import { CheckoutInfo } from "./CheckoutInfo";
import { InsuranceUser } from "./InsuranceUser";
import { InterestedParty } from "./InterestedParty";
import { InsuranceAddress } from "./InsuranceAddress";
import { PaymentMethod } from "./PaymentMethod";

export class Checkout {
  info = new CheckoutInfo();
  roommates: InsuranceUser[] = [];
  interestedParty = new InterestedParty();
  authorizedUsers: InsuranceUser[] = [];
  communityName = "";
  useSameAddressForMailing = true;
  mailingAddress = new InsuranceAddress();
  paymentMethod = new PaymentMethod();
  schoolCity = "";
  schoolKey = "";
  schoolName = "";
  receiveByEmailConsent = false;
}
